import OnlyOne from './OnlyOne'

export default OnlyOne
